<!-- /src/components/common/Sidebar/Filter.vue -->
<template>
  <div class="form__control">
    <div class="filter" :class="'filter--' + filter.type">
      <template v-if="filterHasOptions && filter.type === 'select'">
        <div
          class="filter__label"
          @click="useFilter"
          :class="{
            'filter__label--active': visibleByDefault || selectVisible,
          }"
        >
          <span class="filter__label__text">{{ filter.label }}</span>
          <span class="filter__labelIcon">
            <i class="filter__labelIcon__icon fal fa-angle-right"></i>
          </span>
        </div>
        <template
          v-if="
            filter.includeInputFilter && (visibleByDefault || selectVisible)
          "
        >
          <input
            type="text"
            class="filter__label--input"
            :value="filterListInput"
            @input="updateFilterListValue"
            v-on:keyup="runFilterList"
            :placeholder="'Filter ' + filter.label + ' List'"
          />
        </template>
        <transition name="select">
          <ul class="filter__options" v-if="visibleByDefault || selectVisible">
            <li
              v-for="(option, index) in filterOptions"
              class="filter__options__item"
              :class="{ 'filter__options__item--active': optionActive(option) }"
              :key="index"
              @click="mkRouteObj(option)"
            >
              <i v-if="optionActive(option)" class="fas fa-times-circle"></i>
              {{ option | optionLabel }}
            </li>
          </ul>
        </transition>
      </template>

      <template v-if="filter.type === 'text'">
        <div
          class="filter__label"
          :class="{ 'filter__label--input--active': search }"
        >
          <input
            type="text"
            class="filter__label--input"
            :value="search"
            @input="updateSearchValue"
            v-on:keyup="runSearch"
            :placeholder="filter.label"
          />
          <span class="filter__labelIcon">
            <i class="filter__labelIcon__icon fal fa-search"></i>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import defaults from 'lodash/defaults'
import { deepSearch } from '@/components/common/utils/helpers.js'

export default {
  props: ['filter'],
  data() {
    return {
      selectVisible: false,
      search: '',
      filterListInput: '',
      filterOptions: [],
      active: {},
    }
  },
  filters: {
    optionLabel(option) {
      return option.name || option.label
    },
  },
  computed: {
    filterHasOptions() {
      const { filter } = this
      const optionList = deepSearch(filter, ['options'])
      return Array.isArray(optionList) ? optionList.length > 0 : false
    },

    // @todo figure out why the setter for selectVisible as computed wouldn't change. I might be tired
    visibleByDefault() {
      // if (typeof this.$route.query[this.filter.key] != 'undefined') {
      //   this.selectVisible = true
      // }
      return typeof this.$route.query[this.filter.key] != 'undefined'
        ? true
        : undefined
    },
  },

  watch: {
    visibleByDefault() {
      if (typeof this.$route.query[this.filter.key] != 'undefined') {
        this.selectVisible = true
      }
    },
  },
  methods: {
    mkRouteObj(option) {
      const queryModifier = {}
      const { id, taxonomy } = option
      const { name } = this.$route
      const key = this.filter.key
      this.active = option
      let { ...query } = this.$route.query
      queryModifier['page'] = 1
      // if (key == 'industries') queryModifier['sort_by_meta'] = 'is_mvp'
      if (typeof query[key] != 'undefined' && query[key] == id) {
        // if (key == 'industries') {
        //   delete queryModifier['sort_by_meta']
        //   delete query['sort_by_meta']
        // }
        delete query[key]
      } else {
        queryModifier[key] = id
      }
      query = Object.assign(defaults(queryModifier, query))
      this.$router.push({
        name,
        query,
      })
    },
    updateSearchValue(e) {
      this.search = e.target.value
    },
    updateFilterListValue(e) {
      this.filterListInput = e.target.value
    },
    optionActive(option) {
      const { ...query } = this.$route.query
      const { id } = option
      const key = this.filter.key
      if (typeof query[key] != 'undefined' && query[key] == id) {
        return true
      } else {
        return false
      }
    },
    useFilter() {
      // if (this.selectVisible == true) {
      //   if (this.active.id !== undefined) this.mkRouteObj(this.active)
      //   this.active = {}
      // }
      this.selectVisible = !this.selectVisible
    },
    runFilterList() {
      const { filter, filterListInput } = this
      const output = filter.options.filter(opt => {
        const optionTitle = (opt.name || opt.label).toLowerCase()
        return optionTitle.includes(filterListInput.toLowerCase())
      })
      this.filterOptions = output
    },
    runSearch() {
      const queryModifier = {}
      const { name } = this.$route
      let { ...query } = this.$route.query
      queryModifier['page'] = 1
      if (this.search !== '') {
        queryModifier['search'] = this.search
      } else {
        delete query['search']
      }
      query = Object.assign(defaults(queryModifier, query))
      this.$router.push({
        name,
        query,
      })
    },
  },
  mounted() {
    if (this.filter.type === 'select') {
      // console.log(this.filter.options[0].label)
      // this.filterValue = this.filter.options[0] ? this.filter.options[0].label : false
    }
    this.filterOptions = this.filter.options
    if (this.$route.query && this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
}
</script>

<style scoped>
.filter {
  font-size: 0.6rem;
  box-sizing: border-box;

  &__label {
    display: block;
    position: relative;
    background: white;
    border: 0;
    width: 100%;
    text-align: left;
    font-weight: var(--fontWeightExtraBold);
    color: var(--brandPrimary);
    text-transform: uppercase;
    border-radius: var(--borderRadiusSmall) 30px 30px var(--borderRadiusSmall);
    margin-bottom: 4px;
    cursor: pointer;
    transition: all var(--animationDurationShort) ease;

    &__text {
      display: inline-block;
      padding: 0.65rem;
    }

    &Icon {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      background-color: var(--brandPrimary);
      height: 25px;
      width: 25px;
      border-radius: 50%;
      z-index: 1;
      line-height: 1;
      transform-origin: 50% 50%;
      transition: transform var(--animationDurationShort) ease;

      &__icon {
        color: white;
        /* transform-origin: 50% 45%; */
        transform: translateX(20%);
        font-size: 1.3rem;
        transition: transform var(--animationDurationShort) ease;
      }
    }

    &--active {
      box-shadow: 0 3px 0.25rem rgba(0, 0, 0, 0.1);
      .filter__labelIcon__icon {
        transform: rotate(90deg);
      }
    }

    &--input {
      padding: 0;
      border: 0;
      line-height: 1;
      font-size: inherit;
      padding: 0.65rem;
      color: var(--brandPrimary);
      font-weight: var(--fontWeightExtraBold);

      &--active {
        background-color: var(--brandAccent);
        input {
          color: white;
        }
      }

      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: white;
        font-weight: var(--fontWeightExtraBold);
        text-transform: uppercase;
      }

      &::-moz-placeholder {
        /* Firefox 19+ */
        color: white;
        font-weight: var(--fontWeightExtraBold);
        text-transform: uppercase;
      }

      &:-ms-input-placeholder {
        /* IE 10+ */
        color: white;
        font-weight: var(--fontWeightExtraBold);
        text-transform: uppercase;
      }

      &:-moz-placeholder {
        /* Firefox 18- */
        color: white;
        font-weight: var(--fontWeightExtraBold);
        text-transform: uppercase;
      }
    }

    &:focus {
      outline: none;
    }
  }

  &__options {
    margin: 0;
    font-weight: var(--fontWeightExtraBold);
    text-transform: uppercase;
    color: var(--gray);
    cursor: pointer;
    max-height: 323px;
    overflow-y: scroll;
    overflow-x: hidden;

    &__item {
      background: white;
      margin: 0;
      padding: 0.4rem 1rem 0.4rem 0.5rem;
      margin-bottom: 1px;
      transition: background 500ms;

      &:hover {
        background-color: var(--brandAccent);
        color: white;
      }

      &:first-child {
        border-top-left-radius: var(--borderRadiusSmall);
        border-top-right-radius: var(--borderRadiusSmall);
      }

      &:last-child {
        border-bottom-left-radius: var(--borderRadiusSmall);
        border-bottom-right-radius: var(--borderRadiusSmall);
        margin-bottom: 0;
      }
      svg {
        display: none;
      }

      &--active {
        color: white;
        background-color: var(--brandAccent);
        position: relative;
        &:hover {
          background-color: var(--brandAccent);
        }
        svg {
          display: block;
          position: absolute;
          right: 0.5rem;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }

  &--select {
  }

  &--text {
    .filter__labelIcon__icon {
      font-size: 1rem;
    }
  }
}

a {
  display: block;
}

.form__control {
  margin: 0;
}

.select-enter-active,
.select-leave-active {
  transition: max-height 0.5s ease;
  will-change: max-height;
  overflow: hidden;
  max-height: 500px;
}

.select-enter,
.select-leave-to {
  max-height: 0;
}
</style>
